export const SET_LABELING_HISTORY = "labelingHistory/SET_LABELING_HISTORY";
export const GET_LABELING_HISTORY = "labelingHistory/GET_LABELING_HISTORY";
export const GET_LABELING_HISTORY_SUCCESS =
  "labelingHistory/GET_LABELING_HISTORY_SUCCESS";
export const GET_LABELING_HISTORY_ERROR =
  "labelingHistory/GET_LABELING_HISTORY_ERROR";
export const SET_LABELING_HISTORY_DISPLAY =
  "labelingHistory/SET_LABELING_HISTORY_DISPLAY";
